import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function ResourcesApi(): BringozApi {
  return {
    base: `/scheduleBinding/agents/resource`,
    infiniteScroll: {
      address: `/scheduleBinding/agents/resource`,
      cmd: 'GET'
    },
    actions: {}
  }
}
angular
  .module('bringoz.admin.resources')
  .factory('ResourcesAPI', ResourcesApi);
